import { RowProps } from 'antd';
import clsx from 'clsx';
import { AntRow } from 'components/ant/AntRow';
import React from 'react';

import s from './NotFound.module.less';

export const ModalTitle: React.FC<RowProps> = ({ className, ...rest }) => (
  <AntRow {...rest} className={clsx(s.modalTitle, className)} />
);

export const ModalSubtitle: React.FC<RowProps> = ({ className, ...rest }) => (
  <AntRow {...rest} className={clsx(s.modalSubtitle, className)} />
);
